import { render, staticRenderFns } from "./SaraSettingsSection.vue?vue&type=template&id=63ee870e&scoped=true&"
import script from "./SaraSettingsSection.vue?vue&type=script&lang=ts&"
export * from "./SaraSettingsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee870e",
  null
  
)

export default component.exports